import React, {FC} from "react"
import Flex from "@irati/ui/src/Flex"
import {FormattedNumber} from "react-intl"
import {FormattedCurrency, injectIntl, InjectIntl} from "@irati/utils/lang"
import styled from "styled-components"
import {Body as TextBody} from "@irati/ui/src/Typography"

const Body = styled(TextBody)`
  margin-top: ${({theme}) => theme.spacing.one};
`

const BodyBold = styled(TextBody)`
  font-weight: 800;
`

interface Props extends InjectIntl {
  discountValueInCents: number
  discountValue: string
  flexiPoints?: number
  currency?: string
  amount?: number
  displayTitle?: boolean
}

const FPCashbackFormulaDetails: FC<Props> = ({
  formatMessage,
  discountValue,
  discountValueInCents,
  flexiPoints,
  currency,
  amount,
  displayTitle
}) => {
  const displayedFlexiPoints = flexiPoints ? Math.round(flexiPoints * 100) / 100 : ""

  return (
    <Flex direction="column" padding={displayTitle ? 3 : 0}>
      {displayTitle && <BodyBold>{formatMessage({id: "perks.components.saving.label.pointsNumber"})}</BodyBold>}
      <Flex direction="row">
        <Body>
          {/* eslint-disable-next-line react/style-prop-object */}
          <FormattedNumber style="currency" currency={currency} value={1} />
        </Body>
        <Body style={{marginLeft: 5}}>{` = ${displayedFlexiPoints} ${formatMessage({id: "perks.components.saving.label.points"})}`}</Body>
      </Flex>
      <Flex direction="row">
        <Body>{`${formatMessage({id: "perks.components.saving.label.discount"})} =`}</Body>
        <Body style={{marginLeft: 5}}>
          <FormattedCurrency value={discountValueInCents} currency={currency} />
        </Body>
      </Flex>
      <Body>{`${discountValue} x ${displayedFlexiPoints} = ${amount} ${formatMessage({
        id: "perks.components.saving.label.points"
      })}`}</Body>
    </Flex>
  )
}

export default injectIntl(FPCashbackFormulaDetails)
